'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Warning = require('./Warning');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Warning).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Warning/index.js
// module id = 1316
// module chunks = 1